import React from "react";
import { MapPin } from "lucide-react";
import { NEARBY_AREAS } from "@/lib/brand";

export default function ServiceArea() {
  return (
    <section data-testid="area-section" id="service-area" className="py-16 md:py-24 bg-mint">
      <div className="container-x">
        <div className="max-w-2xl">
          <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">
            Based in Whitefield — <span className="text-brand">serving all of Bangalore.</span>
          </h2>
          <p className="mt-3 text-ink/85">We work across the city. Response is fastest in East Bangalore, but no neighbourhood is out of range.</p>
        </div>

        <div className="mt-10 grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-7">
            <div className="rounded-3xl overflow-hidden shadow-card border border-navy/10 bg-white">
              <iframe
                title="Velixa Health service area"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d124424.76996!2d77.5946!3d12.9716!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670c9b44e6d%3A0xf8dfc3e8517e4fe0!2sBengaluru!5e0!3m2!1sen!2sin!4v1700000000000"
                width="100%" height="420" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="col-span-12 lg:col-span-5">
            <div className="flex flex-wrap gap-2">
              {NEARBY_AREAS.map((a) => (
                <span key={a} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-white border border-navy/10 text-[13.5px] font-semibold text-navy">
                  <MapPin className="w-3.5 h-3.5 text-care" /> {a}
                </span>
              ))}
              <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-care text-white text-[13.5px] font-semibold">
                + all of Bangalore
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
